import { DateTime } from "luxon";
import React, { Dispatch, useMemo } from "react";

import { IgButton, IgSwitch, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";
import { useIsMutating } from "@tanstack/react-query";

interface SettingsTabProps {
  index: number;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const PhaseSettings = ({
  index,
  payload,
  dispatchPayload,
}: SettingsTabProps) => {
  const phase = payload.phases[payload.phaseIndex];
  const now = useMemo(() => DateTime.now(), []);
  const loading = useIsMutating({ mutationKey: ["postStripeApi"] }) > 0;

  return (
    <Grid container item direction={"column"} rowSpacing={2} ml={2} pr={3}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Grid item>
          <IgTypography variant={"h6"}>Phase Settings:</IgTypography>
        </Grid>
        <Grid
          container
          item
          direction={"row"}
          rowSpacing={2}
          ml={2}
          alignItems={"center"}
        >
          <Grid item>
            <IgSwitch
              sx={{ marginLeft: 0 }}
              size={"small"}
              disabled={loading}
              checked={!!phase.trialEndTs}
              color="primary"
              onClick={() => {
                if (phase.trialEndTs) {
                  dispatchPayload({
                    type: "setTrialEndTs",
                    value: undefined,
                  });
                } else {
                  dispatchPayload({
                    type: "setTrialEndTs",
                    value: DateTime.now().plus({ days: 7 }).toSeconds(),
                  });
                }
              }}
              label={"Free Trial"}
            />
          </Grid>
          {phase.trialEndTs ? (
            <Grid item>
              <DatePicker
                disableFuture={false}
                minDate={now}
                label="Free Trial"
                disabled={loading}
                value={DateTime.fromSeconds(phase.trialEndTs)}
                onChange={(newValue) => {
                  dispatchPayload({
                    type: "setTrialEndTs",
                    value: newValue?.toSeconds(),
                  });
                }}
              />
            </Grid>
          ) : null}
        </Grid>
        <Grid item textAlign={"end"}>
          <IgButton
            igVariant={"stripe"}
            sx={{ width: "87px" }}
            onClick={() => {
              if (payload.mode === "create") {
                dispatchPayload({ type: "setTabIndex", value: index + 1 });
              } else {
                dispatchPayload({ type: "setPhaseIndex", value: -1 });
              }
            }}
          >
            Continue
          </IgButton>
        </Grid>
      </LocalizationProvider>
    </Grid>
  );
};
